import React from 'react';
import type ServicedeskQueuesAgentAndIssueViewType from '@jira/spa-apps__servicedesk-queues-agent-and-issue-view/src/SpaApp.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

export const LazyServicedeskQueuesAgentAndIssueView: LazyComponent<
	typeof ServicedeskQueuesAgentAndIssueViewType
> = lazyForPaint<typeof ServicedeskQueuesAgentAndIssueViewType>(
	() => {
		return markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-queues-agent-and-issue-view", jiraSpaEntry: "async-servicedesk-queues-agent-and-issue-view" */ '@jira/spa-apps__servicedesk-queues-agent-and-issue-view/src/SpaApp.tsx'
			),
		);
	},
	{ entryFsSsrLiftImportToModule: true },
);

type Props = RouteContext;

const emptyEntryPointProps: React.ComponentProps<typeof LazyServicedeskQueuesAgentAndIssueView> = {
	entryPoints: {},
	extraProps: {},
	props: {},
	queries: {},
};

const LazyServicedeskQueuesAgentAndIssueViewWithSsrError = () => {
	return <LazyServicedeskQueuesAgentAndIssueView {...emptyEntryPointProps} />;
};

export const CustomQueueRouteComponent = ({ match }: Props): React.JSX.Element => {
	const queueId = (match.params && match.params.queueId) || '';
	const issueKey = (match.params && match.params.issueKey) || '';
	return (
		<LazyPage
			Page={LazyServicedeskQueuesAgentAndIssueViewWithSsrError}
			pageId={`spa-apps/servicedesk/queues/${queueId}/${issueKey}`}
			shouldShowSpinner={!fg('jsm_views_inside_queues_-_main_flag')}
		/>
	);
};
